
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import UserGroups from '@/components/UserGroups.vue';
import { AssignmentAssignee, User } from '@/types';

moment.locale('it');

@Component({
  components: { DatePickerDialog, UserGroups },
})
export default class InstallerAssigneesField extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly value!: AssignmentAssignee[];
  @Prop({ type: Array, default: () => [] }) readonly assigneeUsers!: User[];
  @Prop({ type: String, default: 'Installatore' }) readonly label!: string;

  entries: AssignmentAssignee[] = []

  datePickerDialog = false
  datePickerDate: string | null = null
  datePickerTargetIndex: number | null = null

  statusValues = [
    { text: 'Da assegnare', value: 'todo' },
    { text: 'Assegnato', value: 'done' },
  ]

  @Watch('value', { immediate: true })
  onValueChange(val: AssignmentAssignee[]) {
    this.entries = Array.isArray(val)
      ? val.map((a) => ({
        assigneeId: a.assigneeId,
        assigneeName: a.assigneeName ?? null,
        status: a.status || 'todo',
        assignedDate: a.assignedDate ?? null,
      }))
      : [];
  }

  emitChange() {
    this.$emit('input', this.entries.map((e) => ({ ...e })));
  }

  addEntry() {
    this.entries.push({
      assigneeId: null, assigneeName: null, status: 'todo', assignedDate: null,
    });
    this.emitChange();
  }

  removeEntry(index: number) {
    this.entries.splice(index, 1);
    this.emitChange();
  }

  // La data non viene precompilata su 'done' (issue #1169): la inserisce l'utente.
  // Su 'todo' viene azzerata, coerentemente col backend che non la persiste.
  onStatusChange(index: number) {
    const entry = this.entries[index];
    if (entry.status !== 'done') {
      entry.assignedDate = null;
    }
    this.emitChange();
  }

  onClickDate(index: number) {
    this.datePickerTargetIndex = index;
    const entry = this.entries[index];
    this.datePickerDate = entry.assignedDate
      ? moment(entry.assignedDate).toISOString(true).substring(0, 10)
      : null;
    this.datePickerDialog = true;
  }

  onSelectDate(date: string | null) {
    this.datePickerDialog = false;
    if (this.datePickerTargetIndex === null) return;
    const entry = this.entries[this.datePickerTargetIndex];
    if (entry) {
      entry.assignedDate = date ? moment(date, 'YYYY-MM-DD').toDate() : null;
      this.emitChange();
    }
  }

  mDate(date: Date | string | null): string | null {
    return date ? moment(date).format('L') : null;
  }
}
